import { makeStyles } from '@material-ui/styles';

const MOBILE_HEADER_HEIGHT = 64;
const CONTROL_BAR_HEIGHT = 96;

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.colors.white,
    [theme.breakpoints.up('mobile')]: {
      height: 'unset',
      display: 'flex',
      justifyContent: 'center',
    },
  },
  headerText: {
    fontSize: 16,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 24,
    },
  },
  paper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      maxWidth: 1280,
      minWidth: 800,
      padding: [0, theme.spacing(2)],
      height: 'unset',
    },
  },
  header: {
    display: 'flex',
    height: MOBILE_HEADER_HEIGHT,
    width: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: [1, 'solid', theme.palette.colors.border],
    [theme.breakpoints.up('mobile')]: {
      justifyContent: 'space-between',
      height: 'unset',
      margin: [theme.spacing(4), 0],
      border: 'none',
    },
  },
  content: {
    height: `calc(100% - ${MOBILE_HEADER_HEIGHT + CONTROL_BAR_HEIGHT}px)`,
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      height: 'unset',
      overflow: 'unset',
      marginBottom: 100,
    },
  },
  controlBar: {
    height: CONTROL_BAR_HEIGHT,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3),
    borderTop: [1, 'solid', theme.palette.colors.border],
    [theme.breakpoints.up('mobile')]: {
      position: 'fixed',
      bottom: 0,
      right: 0,
      left: 0,
      backgroundColor: theme.palette.colors.white,
      height: 'unset',
      padding: 10,
      alignItems: 'unset',
      border: 'none',
    },
  },
  mobileButton: {
    position: 'absolute',
    right: theme.spacing(2),
  },
  submitButton: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      height: 48,
      width: 200,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRequestPage/useStyles.js